import * as i0 from '@angular/core';
import * as i1 from './layout.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@abp/ng.core';
import * as i6 from '@swimlane/ngx-datatable';
import * as i7 from '@abp/ng.theme.shared';
import * as i8 from '@angular/cdk/bidi';
import * as i9 from 'ng-zorro-antd/breadcrumb';
import * as i10 from '@delon/abc/page-header';
import * as i11 from '@delon/theme/theme-btn';
import * as i12 from '@delon/theme/setting-drawer';
import * as i13 from '@delon/theme/layout-default';
import * as i14 from '@ngx-translate/core';
import * as i15 from '@delon/abc/notice-icon';
import * as i16 from '@delon/abc/global-footer';
import * as i17 from 'ng-zorro-antd/menu';
import * as i18 from 'ng-zorro-antd/dropdown';
import * as i19 from 'ng-zorro-antd/input';
import * as i20 from 'ng-zorro-antd/auto-complete';
import * as i21 from 'ng-zorro-antd/grid';
import * as i22 from 'ng-zorro-antd/form';
import * as i23 from 'ng-zorro-antd/spin';
import * as i24 from 'ng-zorro-antd/badge';
import * as i25 from 'ng-zorro-antd/avatar';
import * as i26 from 'ng-zorro-antd/icon';
import * as i27 from 'ng-zorro-antd/card';
import * as i28 from './components/basic/basic.component';
import * as i29 from './components/blank/blank.component';
import * as i30 from './components/basic/widgets/search.component';
import * as i31 from './components/basic/widgets/notify.component';
import * as i32 from './components/basic/widgets/task.component';
import * as i33 from './components/basic/widgets/icon.component';
import * as i34 from './components/basic/widgets/fullscreen.component';
import * as i35 from './components/basic/widgets/i18n.component';
import * as i36 from './components/basic/widgets/clear-storage.component';
import * as i37 from './components/basic/widgets/user.component';
import * as i38 from './components/basic/widgets/rtl.component';
import * as i39 from './components/passport/passport.component';
import * as i40 from './components/basic/widgets/breadcrumb.component';
export const LayoutModuleNgFactory:i0.NgModuleFactory<i1.LayoutModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.RouterOutlet = (<any>(null as any));
var _decl0_38:i4.RouterLink = (<any>(null as any));
var _decl0_39:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_40:i4.RouterLinkActive = (<any>(null as any));
var _decl0_41:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_42:i5.ɵl<any,any> = (<any>(null as any));
var _decl0_43:i5.ɵm = (<any>(null as any));
var _decl0_44:i5.ɵn = (<any>(null as any));
var _decl0_45:i5.ɵr = (<any>(null as any));
var _decl0_46:i5.ɵs = (<any>(null as any));
var _decl0_47:i5.ɵt = (<any>(null as any));
var _decl0_48:i5.ɵu = (<any>(null as any));
var _decl0_49:i5.ɵv = (<any>(null as any));
var _decl0_50:i5.ɵx = (<any>(null as any));
var _decl0_51:i5.ɵy = (<any>(null as any));
var _decl0_52:i5.ɵz = (<any>(null as any));
var _decl0_53:i5.ɵbb = (<any>(null as any));
var _decl0_54:i5.ɵbc = (<any>(null as any));
var _decl0_55:i6.DatatableComponent = (<any>(null as any));
var _decl0_56:i6.DatatableRowDetailDirective = (<any>(null as any));
var _decl0_57:i6.DatatableGroupHeaderDirective = (<any>(null as any));
var _decl0_58:i6.DatatableRowDetailTemplateDirective = (<any>(null as any));
var _decl0_59:i6.DataTableColumnDirective = (<any>(null as any));
var _decl0_60:i6.DataTableColumnHeaderDirective = (<any>(null as any));
var _decl0_61:i6.DataTableColumnCellDirective = (<any>(null as any));
var _decl0_62:i6.DataTableColumnCellTreeToggle = (<any>(null as any));
var _decl0_63:i6.DataTableFooterTemplateDirective = (<any>(null as any));
var _decl0_64:i6.DatatableFooterDirective = (<any>(null as any));
var _decl0_65:i6.DataTablePagerComponent = (<any>(null as any));
var _decl0_66:i6.DatatableGroupHeaderTemplateDirective = (<any>(null as any));
var _decl0_67:i7.ɵa = (<any>(null as any));
var _decl0_68:i7.ɵc = (<any>(null as any));
var _decl0_69:i7.ɵd = (<any>(null as any));
var _decl0_70:i7.ɵe = (<any>(null as any));
var _decl0_71:i7.ɵf = (<any>(null as any));
var _decl0_72:i7.ɵg = (<any>(null as any));
var _decl0_73:i7.ɵh = (<any>(null as any));
var _decl0_74:i7.ɵi = (<any>(null as any));
var _decl0_75:i7.ɵm = (<any>(null as any));
var _decl0_76:i7.ɵn = (<any>(null as any));
var _decl0_77:i7.ɵo = (<any>(null as any));
var _decl0_78:i7.ɵq = (<any>(null as any));
var _decl0_79:i7.ɵs = (<any>(null as any));
var _decl0_80:i7.ɵt = (<any>(null as any));
var _decl0_81:i7.ɵu = (<any>(null as any));
var _decl0_82:i7.ɵv = (<any>(null as any));
var _decl0_83:i7.ɵw = (<any>(null as any));
var _decl0_84:i7.ɵx = (<any>(null as any));
var _decl0_85:i8.Dir = (<any>(null as any));
var _decl0_86:i9.NzBreadCrumbComponent = (<any>(null as any));
var _decl0_87:i9.NzBreadCrumbItemComponent = (<any>(null as any));
var _decl0_88:i9.NzBreadCrumbSeparatorComponent = (<any>(null as any));
var _decl0_89:i10.PageHeaderComponent = (<any>(null as any));
var _decl0_90:i11.ThemeBtnComponent = (<any>(null as any));
var _decl0_91:i12.SettingDrawerItemComponent = (<any>(null as any));
var _decl0_92:i12.SettingDrawerComponent = (<any>(null as any));
var _decl0_93:i13.LayoutDefaultComponent = (<any>(null as any));
var _decl0_94:i13.LayoutDefaultNavComponent = (<any>(null as any));
var _decl0_95:i13.LayoutDefaultHeaderComponent = (<any>(null as any));
var _decl0_96:i13.LayoutDefaultHeaderItemComponent = (<any>(null as any));
var _decl0_97:i13.LayoutDefaultHeaderItemTriggerDirective = (<any>(null as any));
var _decl0_98:i14.TranslateDirective = (<any>(null as any));
var _decl0_99:i15.NoticeIconComponent = (<any>(null as any));
var _decl0_100:i16.GlobalFooterComponent = (<any>(null as any));
var _decl0_101:i16.GlobalFooterItemComponent = (<any>(null as any));
var _decl0_102:i17.NzMenuDirective = (<any>(null as any));
var _decl0_103:i17.NzMenuItemDirective = (<any>(null as any));
var _decl0_104:i17.NzSubMenuComponent = (<any>(null as any));
var _decl0_105:i17.NzMenuDividerDirective = (<any>(null as any));
var _decl0_106:i17.NzMenuGroupComponent = (<any>(null as any));
var _decl0_107:i18.NzDropDownDirective = (<any>(null as any));
var _decl0_108:i18.NzDropDownADirective = (<any>(null as any));
var _decl0_109:i18.NzDropdownMenuComponent = (<any>(null as any));
var _decl0_110:i18.NzDropdownButtonDirective = (<any>(null as any));
var _decl0_111:i19.NzTextareaCountComponent = (<any>(null as any));
var _decl0_112:i19.NzInputDirective = (<any>(null as any));
var _decl0_113:i19.NzInputGroupComponent = (<any>(null as any));
var _decl0_114:i19.NzAutosizeDirective = (<any>(null as any));
var _decl0_115:i19.NzInputGroupWhitSuffixOrPrefixDirective = (<any>(null as any));
var _decl0_116:i20.NzAutocompleteComponent = (<any>(null as any));
var _decl0_117:i20.NzAutocompleteOptionComponent = (<any>(null as any));
var _decl0_118:i20.NzAutocompleteTriggerDirective = (<any>(null as any));
var _decl0_119:i20.NzAutocompleteOptgroupComponent = (<any>(null as any));
var _decl0_120:i21.NzColDirective = (<any>(null as any));
var _decl0_121:i21.NzRowDirective = (<any>(null as any));
var _decl0_122:i22.NzFormDirective = (<any>(null as any));
var _decl0_123:i22.NzFormItemComponent = (<any>(null as any));
var _decl0_124:i22.NzFormLabelComponent = (<any>(null as any));
var _decl0_125:i22.NzFormControlComponent = (<any>(null as any));
var _decl0_126:i22.NzFormTextComponent = (<any>(null as any));
var _decl0_127:i22.NzFormSplitComponent = (<any>(null as any));
var _decl0_128:i23.NzSpinComponent = (<any>(null as any));
var _decl0_129:i24.NzBadgeComponent = (<any>(null as any));
var _decl0_130:i24.ɵb = (<any>(null as any));
var _decl0_131:i25.NzAvatarComponent = (<any>(null as any));
var _decl0_132:i25.ɵa = (<any>(null as any));
var _decl0_133:i26.NzIconDirective = (<any>(null as any));
var _decl0_134:i27.NzCardComponent = (<any>(null as any));
var _decl0_135:i27.NzCardGridDirective = (<any>(null as any));
var _decl0_136:i27.NzCardMetaComponent = (<any>(null as any));
var _decl0_137:i27.NzCardLoadingComponent = (<any>(null as any));
var _decl0_138:i27.NzCardTabComponent = (<any>(null as any));
var _decl0_139:i28.LayoutBasicComponent = (<any>(null as any));
var _decl0_140:i29.LayoutBlankComponent = (<any>(null as any));
var _decl0_141:i30.HeaderSearchComponent = (<any>(null as any));
var _decl0_142:i31.HeaderNotifyComponent = (<any>(null as any));
var _decl0_143:i32.HeaderTaskComponent = (<any>(null as any));
var _decl0_144:i33.HeaderIconComponent = (<any>(null as any));
var _decl0_145:i34.HeaderFullScreenComponent = (<any>(null as any));
var _decl0_146:i35.HeaderI18nComponent = (<any>(null as any));
var _decl0_147:i36.HeaderClearStorageComponent = (<any>(null as any));
var _decl0_148:i37.HeaderUserComponent = (<any>(null as any));
var _decl0_149:i38.HeaderRTLComponent = (<any>(null as any));
var _decl0_150:i39.LayoutPassportComponent = (<any>(null as any));
var _decl0_151:i40.BreadcrumbComponent = (<any>(null as any));
var _decl0_152:i2.AsyncPipe = (<any>(null as any));
var _decl0_153:i2.UpperCasePipe = (<any>(null as any));
var _decl0_154:i2.LowerCasePipe = (<any>(null as any));
var _decl0_155:i2.JsonPipe = (<any>(null as any));
var _decl0_156:i2.SlicePipe = (<any>(null as any));
var _decl0_157:i2.DecimalPipe = (<any>(null as any));
var _decl0_158:i2.PercentPipe = (<any>(null as any));
var _decl0_159:i2.TitleCasePipe = (<any>(null as any));
var _decl0_160:i2.CurrencyPipe = (<any>(null as any));
var _decl0_161:i2.DatePipe = (<any>(null as any));
var _decl0_162:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_163:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_164:i2.KeyValuePipe = (<any>(null as any));
var _decl0_165:i5.ɵb = (<any>(null as any));
var _decl0_166:i5.ɵba = (<any>(null as any));
var _decl0_167:i14.TranslatePipe = (<any>(null as any));
var _decl0_168:i5.CoreModule = (<any>(null as any));
var _decl0_169:i7.ThemeSharedModule = (<any>(null as any));
var _decl0_170:i9.NzBreadCrumbModule = (<any>(null as any));
var _decl0_171:i10.PageHeaderModule = (<any>(null as any));
var _decl0_172:i2.CommonModule = (<any>(null as any));
var _decl0_173:i3.FormsModule = (<any>(null as any));
var _decl0_174:i4.RouterModule = (<any>(null as any));
var _decl0_175:i11.ThemeBtnModule = (<any>(null as any));
var _decl0_176:i12.SettingDrawerModule = (<any>(null as any));
var _decl0_177:i13.LayoutDefaultModule = (<any>(null as any));
var _decl0_178:i14.TranslateModule = (<any>(null as any));
var _decl0_179:i15.NoticeIconModule = (<any>(null as any));
var _decl0_180:i16.GlobalFooterModule = (<any>(null as any));
var _decl0_181:i18.NzDropDownModule = (<any>(null as any));
var _decl0_182:i19.NzInputModule = (<any>(null as any));
var _decl0_183:i20.NzAutocompleteModule = (<any>(null as any));
var _decl0_184:i21.NzGridModule = (<any>(null as any));
var _decl0_185:i22.NzFormModule = (<any>(null as any));
var _decl0_186:i23.NzSpinModule = (<any>(null as any));
var _decl0_187:i24.NzBadgeModule = (<any>(null as any));
var _decl0_188:i25.NzAvatarModule = (<any>(null as any));
var _decl0_189:i26.NzIconModule = (<any>(null as any));
var _decl0_190:i27.NzCardModule = (<any>(null as any));
var _decl0_191:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_192:i0.ElementRef<any> = (<any>(null as any));
function _View_LayoutBasicComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_LayoutBasicComponent_1_1():void {
  var _any:any = (null as any);
}
function _View_LayoutBasicComponent_1_2():void {
  var _any:any = (null as any);
}
function _View_LayoutBasicComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_139.options;
  currVal_0;
  const currVal_1:any = _decl0_191;
  currVal_1;
  const currVal_2:any = _decl0_191;
  currVal_2;
  const currVal_3:any = 'mobile';
  currVal_3;
  const currVal_4:any = 'right';
  currVal_4;
  const currVal_5:any = true;
  currVal_5;
  const currVal_6:any = _decl0_109;
  currVal_6;
  const currVal_7:any = 'click';
  currVal_7;
  const currVal_8:any = 'bottomRight';
  currVal_8;
  const currVal_9:any = 'setting';
  currVal_9;
  const currVal_10:any = true;
  currVal_10;
  const currVal_11:any = _decl0_102.isMenuInsideDropDown;
  currVal_11;
  const currVal_12:any = _decl0_102.isMenuInsideDropDown;
  currVal_12;
  const currVal_13:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_13;
  const currVal_14:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_14;
  const currVal_15:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_15;
  const currVal_16:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_16;
  const currVal_17:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_17;
  const currVal_18:any = (_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_18;
  const currVal_19:any = !_decl0_102.isMenuInsideDropDown;
  currVal_19;
  const currVal_20:any = !_decl0_102.isMenuInsideDropDown;
  currVal_20;
  const currVal_21:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_21;
  const currVal_22:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_22;
  const currVal_23:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_23;
  const currVal_24:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_24;
  const currVal_25:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_25;
  const currVal_26:any = (!_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_26;
  const currVal_27:any = (_decl0_102.dir === 'rtl');
  currVal_27;
  const currVal_28:any = _decl0_103.isMenuInsideDropDown;
  currVal_28;
  const currVal_29:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_29;
  const currVal_30:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_30;
  const currVal_31:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_31;
  const currVal_32:any = !_decl0_103.isMenuInsideDropDown;
  currVal_32;
  const currVal_33:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_33;
  const currVal_34:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_34;
  const currVal_35:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_35;
  const currVal_36:any = ((_decl0_103.dir === 'rtl')? null: (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft));
  currVal_36;
  const currVal_37:any = ((_decl0_103.dir === 'rtl')? (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft): null);
  currVal_37;
  const currVal_38:any = 'right';
  currVal_38;
  const pd_39:any = ((<any>_decl0_103.clickMenuItem(_any)) !== false);
}
function _View_LayoutBlankComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
}
function _View_LayoutBlankComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_HeaderSearchComponent_Host_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_141.focus;
  currVal_0;
  const currVal_1:any = _decl0_141.searchToggled;
  currVal_1;
}
function _View_HeaderSearchComponent_3_1():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_141.focus? 'arrow-down': 'search');
  currVal_0;
  const currVal_1:any = true;
  currVal_1;
}
function _View_HeaderSearchComponent_3_3():void {
  if (_decl0_141.loading) {
    var _any:any = (null as any);
    const currVal_0:any = 'loading';
    currVal_0;
    const currVal_1:any = true;
    currVal_1;
  }
}
function _View_HeaderSearchComponent_3_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_141.loading;
  currVal_0;
}
function _View_HeaderSearchComponent_3_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _decl0_117.nzAutocompleteOptgroupComponent;
  currVal_1;
  const currVal_2:any = _decl0_117.selected;
  currVal_2;
  const currVal_3:any = _decl0_117.active;
  currVal_3;
  const currVal_4:any = _decl0_117.nzDisabled;
  currVal_4;
  const currVal_5:any = _decl0_117.selected.toString();
  currVal_5;
  const currVal_6:any = _decl0_117.nzDisabled.toString();
  currVal_6;
  const currVal_7:any = _any;
  currVal_7;
  const pd_8:any = ((<any>_decl0_117.selectViaInteraction()) !== false);
  const pd_9:any = ((<any>_decl0_117.onMouseEnter()) !== false);
  const pd_10:any = ((<any>_any.preventDefault()) !== false);
}
function _View_HeaderSearchComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_191;
  currVal_0;
  const currVal_1:any = _decl0_191;
  currVal_1;
  const currVal_2:any = _decl0_113.nzCompact;
  currVal_2;
  const currVal_3:any = _decl0_113.nzSearch;
  currVal_3;
  const currVal_4:any = _decl0_113.nzSearch;
  currVal_4;
  const currVal_5:any = (_decl0_113.dir === 'rtl');
  currVal_5;
  const currVal_6:any = (_decl0_113.nzSearch && _decl0_113.isSmall);
  currVal_6;
  const currVal_7:any = (_decl0_113.nzSearch && _decl0_113.isLarge);
  currVal_7;
  const currVal_8:any = _decl0_113.isAddOn;
  currVal_8;
  const currVal_9:any = (_decl0_113.dir === 'rtl');
  currVal_9;
  const currVal_10:any = (_decl0_113.isAddOn && _decl0_113.isLarge);
  currVal_10;
  const currVal_11:any = (_decl0_113.isAddOn && _decl0_113.isSmall);
  currVal_11;
  const currVal_12:any = (_decl0_113.isAffix && !_decl0_113.isAddOn);
  currVal_12;
  const currVal_13:any = (_decl0_113.dir === 'rtl');
  currVal_13;
  const currVal_14:any = (_decl0_113.isAffix && _decl0_113.focused);
  currVal_14;
  const currVal_15:any = (_decl0_113.isAffix && _decl0_113.disabled);
  currVal_15;
  const currVal_16:any = ((_decl0_113.isAffix && !_decl0_113.isAddOn) && _decl0_113.isLarge);
  currVal_16;
  const currVal_17:any = ((_decl0_113.isAffix && !_decl0_113.isAddOn) && _decl0_113.isSmall);
  currVal_17;
  const currVal_18:any = (!_decl0_113.isAffix && !_decl0_113.isAddOn);
  currVal_18;
  const currVal_19:any = (_decl0_113.dir === 'rtl');
  currVal_19;
  const currVal_20:any = ((!_decl0_113.isAffix && !_decl0_113.isAddOn) && _decl0_113.isLarge);
  currVal_20;
  const currVal_21:any = ((!_decl0_113.isAffix && !_decl0_113.isAddOn) && _decl0_113.isSmall);
  currVal_21;
  const currVal_22:any = _decl0_116;
  currVal_22;
  const currVal_23:any = _decl0_141.q;
  currVal_23;
  const currVal_24:any = _decl0_21.is('untouched');
  currVal_24;
  const currVal_25:any = _decl0_21.is('touched');
  currVal_25;
  const currVal_26:any = _decl0_21.is('pristine');
  currVal_26;
  const currVal_27:any = _decl0_21.is('dirty');
  currVal_27;
  const currVal_28:any = _decl0_21.is('valid');
  currVal_28;
  const currVal_29:any = _decl0_21.is('invalid');
  currVal_29;
  const currVal_30:any = _decl0_21.is('pending');
  currVal_30;
  const currVal_31:any = _decl0_112.disabled;
  currVal_31;
  const currVal_32:any = _decl0_112.nzBorderless;
  currVal_32;
  const currVal_33:any = (_decl0_112.nzSize === 'large');
  currVal_33;
  const currVal_34:any = (_decl0_112.nzSize === 'small');
  currVal_34;
  const currVal_35:any = (_decl0_112.disabled || null);
  currVal_35;
  const currVal_36:any = (_decl0_112.dir === 'rtl');
  currVal_36;
  const currVal_37:any = 'menu.search.placeholder';
  currVal_37;
  const currVal_38:any = '';
  currVal_38;
  const currVal_39:any = _decl0_141.options;
  currVal_39;
  const pd_40:any = ((<any>(<any>_decl0_14)._handleInput(_any.target.value)) !== false);
  const pd_41:any = ((<any>_decl0_14.onTouched()) !== false);
  const pd_42:any = ((<any>(<any>_decl0_14)._compositionStart()) !== false);
  const pd_43:any = ((<any>(<any>_decl0_14)._compositionEnd(_any.target.value)) !== false);
  const pd_44:any = ((<any>_decl0_118.handleFocus()) !== false);
  const pd_45:any = ((<any>_decl0_118.handleBlur()) !== false);
  const pd_46:any = ((<any>_decl0_118.handleInput(_any)) !== false);
  const pd_47:any = ((<any>_decl0_118.handleKeydown(_any)) !== false);
  const pd_48:any = ((<any>(_decl0_141.q = _any)) !== false);
  const pd_49:any = ((<any>_decl0_141.search(_any)) !== false);
  const pd_50:any = ((<any>_decl0_141.qFocus()) !== false);
  const pd_51:any = ((<any>_decl0_141.qBlur()) !== false);
}
function _View_HeaderNotifyComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_HeaderNotifyComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_142.data;
  currVal_0;
  const currVal_1:any = _decl0_142.count;
  currVal_1;
  const currVal_2:any = _decl0_142.loading;
  currVal_2;
  const currVal_3:any = 'alain-default__nav-item';
  currVal_3;
  const currVal_4:any = 'alain-default__nav-item-icon';
  currVal_4;
  const currVal_5:any = true;
  currVal_5;
  const pd_6:any = ((<any>_decl0_142.select(_any)) !== false);
  const pd_7:any = ((<any>_decl0_142.clear(_any)) !== false);
  const pd_8:any = ((<any>_decl0_142.loadData()) !== false);
}
function _View_HeaderTaskComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_HeaderTaskComponent_5_1():void {
  if (_decl0_143.loading) {
    var _any:any = (null as any);
    const currVal_0:any = !_decl0_128.nzSimple;
    currVal_0;
  }
}
function _View_HeaderTaskComponent_5_3():void {
  if (!_decl0_143.loading) {
    var _any:any = (null as any);
    const currVal_0:any = 'plus';
    currVal_0;
    const currVal_1:any = true;
    currVal_1;
  }
}
function _View_HeaderTaskComponent_5_2():void {
  if (!_decl0_143.loading) {
    var _any:any = (null as any);
    const currVal_0:any = 'false';
    currVal_0;
    const currVal_1:any = 'Notifications';
    currVal_1;
    const currVal_2:any = _decl0_134.nzLoading;
    currVal_2;
    const currVal_3:any = ((_decl0_134.nzBorderless === false) && _decl0_134.nzBordered);
    currVal_3;
    const currVal_4:any = _decl0_134.nzHoverable;
    currVal_4;
    const currVal_5:any = (_decl0_134.nzSize === 'small');
    currVal_5;
    const currVal_6:any = (_decl0_134.listOfNzCardGridDirective && _decl0_134.listOfNzCardGridDirective.length);
    currVal_6;
    const currVal_7:any = (_decl0_134.nzType === 'inner');
    currVal_7;
    const currVal_8:any = !!_decl0_134.listOfNzCardTabComponent;
    currVal_8;
    const currVal_9:any = (_decl0_134.dir === 'rtl');
    currVal_9;
    const currVal_10:any = 'middle';
    currVal_10;
    const currVal_11:any = 'center';
    currVal_11;
    const currVal_12:any = (_decl0_121.nzAlign === 'top');
    currVal_12;
    const currVal_13:any = (_decl0_121.nzAlign === 'middle');
    currVal_13;
    const currVal_14:any = (_decl0_121.nzAlign === 'bottom');
    currVal_14;
    const currVal_15:any = (_decl0_121.nzJustify === 'start');
    currVal_15;
    const currVal_16:any = (_decl0_121.nzJustify === 'end');
    currVal_16;
    const currVal_17:any = (_decl0_121.nzJustify === 'center');
    currVal_17;
    const currVal_18:any = (_decl0_121.nzJustify === 'space-around');
    currVal_18;
    const currVal_19:any = (_decl0_121.nzJustify === 'space-between');
    currVal_19;
    const currVal_20:any = (_decl0_121.dir === 'rtl');
    currVal_20;
    const currVal_21:any = 4;
    currVal_21;
    const currVal_22:any = _decl0_120.hostFlexStyle;
    currVal_22;
    const currVal_23:any = './assets/tmp/img/1.png';
    currVal_23;
    const currVal_24:any = (_decl0_131.nzSize === 'large');
    currVal_24;
    const currVal_25:any = (_decl0_131.nzSize === 'small');
    currVal_25;
    const currVal_26:any = (_decl0_131.nzShape === 'square');
    currVal_26;
    const currVal_27:any = (_decl0_131.nzShape === 'circle');
    currVal_27;
    const currVal_28:any = _decl0_131.nzIcon;
    currVal_28;
    const currVal_29:any = _decl0_131.hasSrc;
    currVal_29;
    const currVal_30:any = _decl0_131.customSize;
    currVal_30;
    const currVal_31:any = _decl0_131.customSize;
    currVal_31;
    const currVal_32:any = _decl0_131.customSize;
    currVal_32;
    const currVal_33:any = ((_decl0_131.hasIcon && _decl0_131.customSize)? ((<any>_decl0_131.nzSize) / 2): null);
    currVal_33;
    const currVal_34:any = 20;
    currVal_34;
    const currVal_35:any = _decl0_120.hostFlexStyle;
    currVal_35;
    const currVal_36:any = 'middle';
    currVal_36;
    const currVal_37:any = 'center';
    currVal_37;
    const currVal_38:any = (_decl0_121.nzAlign === 'top');
    currVal_38;
    const currVal_39:any = (_decl0_121.nzAlign === 'middle');
    currVal_39;
    const currVal_40:any = (_decl0_121.nzAlign === 'bottom');
    currVal_40;
    const currVal_41:any = (_decl0_121.nzJustify === 'start');
    currVal_41;
    const currVal_42:any = (_decl0_121.nzJustify === 'end');
    currVal_42;
    const currVal_43:any = (_decl0_121.nzJustify === 'center');
    currVal_43;
    const currVal_44:any = (_decl0_121.nzJustify === 'space-around');
    currVal_44;
    const currVal_45:any = (_decl0_121.nzJustify === 'space-between');
    currVal_45;
    const currVal_46:any = (_decl0_121.dir === 'rtl');
    currVal_46;
    const currVal_47:any = 4;
    currVal_47;
    const currVal_48:any = _decl0_120.hostFlexStyle;
    currVal_48;
    const currVal_49:any = './assets/tmp/img/2.png';
    currVal_49;
    const currVal_50:any = (_decl0_131.nzSize === 'large');
    currVal_50;
    const currVal_51:any = (_decl0_131.nzSize === 'small');
    currVal_51;
    const currVal_52:any = (_decl0_131.nzShape === 'square');
    currVal_52;
    const currVal_53:any = (_decl0_131.nzShape === 'circle');
    currVal_53;
    const currVal_54:any = _decl0_131.nzIcon;
    currVal_54;
    const currVal_55:any = _decl0_131.hasSrc;
    currVal_55;
    const currVal_56:any = _decl0_131.customSize;
    currVal_56;
    const currVal_57:any = _decl0_131.customSize;
    currVal_57;
    const currVal_58:any = _decl0_131.customSize;
    currVal_58;
    const currVal_59:any = ((_decl0_131.hasIcon && _decl0_131.customSize)? ((<any>_decl0_131.nzSize) / 2): null);
    currVal_59;
    const currVal_60:any = 20;
    currVal_60;
    const currVal_61:any = _decl0_120.hostFlexStyle;
    currVal_61;
    const currVal_62:any = 'middle';
    currVal_62;
    const currVal_63:any = 'center';
    currVal_63;
    const currVal_64:any = (_decl0_121.nzAlign === 'top');
    currVal_64;
    const currVal_65:any = (_decl0_121.nzAlign === 'middle');
    currVal_65;
    const currVal_66:any = (_decl0_121.nzAlign === 'bottom');
    currVal_66;
    const currVal_67:any = (_decl0_121.nzJustify === 'start');
    currVal_67;
    const currVal_68:any = (_decl0_121.nzJustify === 'end');
    currVal_68;
    const currVal_69:any = (_decl0_121.nzJustify === 'center');
    currVal_69;
    const currVal_70:any = (_decl0_121.nzJustify === 'space-around');
    currVal_70;
    const currVal_71:any = (_decl0_121.nzJustify === 'space-between');
    currVal_71;
    const currVal_72:any = (_decl0_121.dir === 'rtl');
    currVal_72;
    const currVal_73:any = 4;
    currVal_73;
    const currVal_74:any = _decl0_120.hostFlexStyle;
    currVal_74;
    const currVal_75:any = './assets/tmp/img/3.png';
    currVal_75;
    const currVal_76:any = (_decl0_131.nzSize === 'large');
    currVal_76;
    const currVal_77:any = (_decl0_131.nzSize === 'small');
    currVal_77;
    const currVal_78:any = (_decl0_131.nzShape === 'square');
    currVal_78;
    const currVal_79:any = (_decl0_131.nzShape === 'circle');
    currVal_79;
    const currVal_80:any = _decl0_131.nzIcon;
    currVal_80;
    const currVal_81:any = _decl0_131.hasSrc;
    currVal_81;
    const currVal_82:any = _decl0_131.customSize;
    currVal_82;
    const currVal_83:any = _decl0_131.customSize;
    currVal_83;
    const currVal_84:any = _decl0_131.customSize;
    currVal_84;
    const currVal_85:any = ((_decl0_131.hasIcon && _decl0_131.customSize)? ((<any>_decl0_131.nzSize) / 2): null);
    currVal_85;
    const currVal_86:any = 20;
    currVal_86;
    const currVal_87:any = _decl0_120.hostFlexStyle;
    currVal_87;
    const currVal_88:any = 'middle';
    currVal_88;
    const currVal_89:any = 'center';
    currVal_89;
    const currVal_90:any = (_decl0_121.nzAlign === 'top');
    currVal_90;
    const currVal_91:any = (_decl0_121.nzAlign === 'middle');
    currVal_91;
    const currVal_92:any = (_decl0_121.nzAlign === 'bottom');
    currVal_92;
    const currVal_93:any = (_decl0_121.nzJustify === 'start');
    currVal_93;
    const currVal_94:any = (_decl0_121.nzJustify === 'end');
    currVal_94;
    const currVal_95:any = (_decl0_121.nzJustify === 'center');
    currVal_95;
    const currVal_96:any = (_decl0_121.nzJustify === 'space-around');
    currVal_96;
    const currVal_97:any = (_decl0_121.nzJustify === 'space-between');
    currVal_97;
    const currVal_98:any = (_decl0_121.dir === 'rtl');
    currVal_98;
    const currVal_99:any = 4;
    currVal_99;
    const currVal_100:any = _decl0_120.hostFlexStyle;
    currVal_100;
    const currVal_101:any = './assets/tmp/img/4.png';
    currVal_101;
    const currVal_102:any = (_decl0_131.nzSize === 'large');
    currVal_102;
    const currVal_103:any = (_decl0_131.nzSize === 'small');
    currVal_103;
    const currVal_104:any = (_decl0_131.nzShape === 'square');
    currVal_104;
    const currVal_105:any = (_decl0_131.nzShape === 'circle');
    currVal_105;
    const currVal_106:any = _decl0_131.nzIcon;
    currVal_106;
    const currVal_107:any = _decl0_131.hasSrc;
    currVal_107;
    const currVal_108:any = _decl0_131.customSize;
    currVal_108;
    const currVal_109:any = _decl0_131.customSize;
    currVal_109;
    const currVal_110:any = _decl0_131.customSize;
    currVal_110;
    const currVal_111:any = ((_decl0_131.hasIcon && _decl0_131.customSize)? ((<any>_decl0_131.nzSize) / 2): null);
    currVal_111;
    const currVal_112:any = 20;
    currVal_112;
    const currVal_113:any = _decl0_120.hostFlexStyle;
    currVal_113;
    const currVal_114:any = 'middle';
    currVal_114;
    const currVal_115:any = 'center';
    currVal_115;
    const currVal_116:any = (_decl0_121.nzAlign === 'top');
    currVal_116;
    const currVal_117:any = (_decl0_121.nzAlign === 'middle');
    currVal_117;
    const currVal_118:any = (_decl0_121.nzAlign === 'bottom');
    currVal_118;
    const currVal_119:any = (_decl0_121.nzJustify === 'start');
    currVal_119;
    const currVal_120:any = (_decl0_121.nzJustify === 'end');
    currVal_120;
    const currVal_121:any = (_decl0_121.nzJustify === 'center');
    currVal_121;
    const currVal_122:any = (_decl0_121.nzJustify === 'space-around');
    currVal_122;
    const currVal_123:any = (_decl0_121.nzJustify === 'space-between');
    currVal_123;
    const currVal_124:any = (_decl0_121.dir === 'rtl');
    currVal_124;
    const currVal_125:any = 4;
    currVal_125;
    const currVal_126:any = _decl0_120.hostFlexStyle;
    currVal_126;
    const currVal_127:any = './assets/tmp/img/5.png';
    currVal_127;
    const currVal_128:any = (_decl0_131.nzSize === 'large');
    currVal_128;
    const currVal_129:any = (_decl0_131.nzSize === 'small');
    currVal_129;
    const currVal_130:any = (_decl0_131.nzShape === 'square');
    currVal_130;
    const currVal_131:any = (_decl0_131.nzShape === 'circle');
    currVal_131;
    const currVal_132:any = _decl0_131.nzIcon;
    currVal_132;
    const currVal_133:any = _decl0_131.hasSrc;
    currVal_133;
    const currVal_134:any = _decl0_131.customSize;
    currVal_134;
    const currVal_135:any = _decl0_131.customSize;
    currVal_135;
    const currVal_136:any = _decl0_131.customSize;
    currVal_136;
    const currVal_137:any = ((_decl0_131.hasIcon && _decl0_131.customSize)? ((<any>_decl0_131.nzSize) / 2): null);
    currVal_137;
    const currVal_138:any = 20;
    currVal_138;
    const currVal_139:any = _decl0_120.hostFlexStyle;
    currVal_139;
    const currVal_140:any = (_decl0_121.nzAlign === 'top');
    currVal_140;
    const currVal_141:any = (_decl0_121.nzAlign === 'middle');
    currVal_141;
    const currVal_142:any = (_decl0_121.nzAlign === 'bottom');
    currVal_142;
    const currVal_143:any = (_decl0_121.nzJustify === 'start');
    currVal_143;
    const currVal_144:any = (_decl0_121.nzJustify === 'end');
    currVal_144;
    const currVal_145:any = (_decl0_121.nzJustify === 'center');
    currVal_145;
    const currVal_146:any = (_decl0_121.nzJustify === 'space-around');
    currVal_146;
    const currVal_147:any = (_decl0_121.nzJustify === 'space-between');
    currVal_147;
    const currVal_148:any = (_decl0_121.dir === 'rtl');
    currVal_148;
    const currVal_149:any = 24;
    currVal_149;
    const currVal_150:any = _decl0_120.hostFlexStyle;
    currVal_150;
  }
}
function _View_HeaderTaskComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_109;
  currVal_0;
  const currVal_1:any = 'click';
  currVal_1;
  const currVal_2:any = 'bottomRight';
  currVal_2;
  const currVal_3:any = true;
  currVal_3;
  const currVal_4:any = _decl0_129.nzStatus;
  currVal_4;
  const currVal_5:any = !!((_decl0_129.nzStandalone || _decl0_129.nzStatus) || _decl0_129.nzColor);
  currVal_5;
  const currVal_6:any = 'bell';
  currVal_6;
  const currVal_7:any = true;
  currVal_7;
  const currVal_8:any = _decl0_102.isMenuInsideDropDown;
  currVal_8;
  const currVal_9:any = _decl0_102.isMenuInsideDropDown;
  currVal_9;
  const currVal_10:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_10;
  const currVal_11:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_11;
  const currVal_12:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_12;
  const currVal_13:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_13;
  const currVal_14:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_14;
  const currVal_15:any = (_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_15;
  const currVal_16:any = !_decl0_102.isMenuInsideDropDown;
  currVal_16;
  const currVal_17:any = !_decl0_102.isMenuInsideDropDown;
  currVal_17;
  const currVal_18:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_18;
  const currVal_19:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_19;
  const currVal_20:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_20;
  const currVal_21:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_21;
  const currVal_22:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_22;
  const currVal_23:any = (!_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_23;
  const currVal_24:any = (_decl0_102.dir === 'rtl');
  currVal_24;
  const currVal_25:any = _decl0_143.loading;
  currVal_25;
  const currVal_26:any = !_decl0_143.loading;
  currVal_26;
  const pd_27:any = ((<any>_decl0_143.change()) !== false);
}
function _View_HeaderIconComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_HeaderIconComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_109;
  currVal_0;
  const currVal_1:any = 'click';
  currVal_1;
  const currVal_2:any = 'bottomRight';
  currVal_2;
  const currVal_3:any = 'appstore';
  currVal_3;
  const currVal_4:any = true;
  currVal_4;
  const currVal_5:any = _decl0_102.isMenuInsideDropDown;
  currVal_5;
  const currVal_6:any = _decl0_102.isMenuInsideDropDown;
  currVal_6;
  const currVal_7:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_7;
  const currVal_8:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_8;
  const currVal_9:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_9;
  const currVal_10:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_10;
  const currVal_11:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_11;
  const currVal_12:any = (_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_12;
  const currVal_13:any = !_decl0_102.isMenuInsideDropDown;
  currVal_13;
  const currVal_14:any = !_decl0_102.isMenuInsideDropDown;
  currVal_14;
  const currVal_15:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_15;
  const currVal_16:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_16;
  const currVal_17:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_17;
  const currVal_18:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_18;
  const currVal_19:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_19;
  const currVal_20:any = (!_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_20;
  const currVal_21:any = (_decl0_102.dir === 'rtl');
  currVal_21;
  const currVal_22:any = '正在读取数据...';
  currVal_22;
  const currVal_23:any = _decl0_144.loading;
  currVal_23;
  const currVal_24:any = !_decl0_128.nzSimple;
  currVal_24;
  const currVal_25:any = 'middle';
  currVal_25;
  const currVal_26:any = 'center';
  currVal_26;
  const currVal_27:any = (_decl0_121.nzAlign === 'top');
  currVal_27;
  const currVal_28:any = (_decl0_121.nzAlign === 'middle');
  currVal_28;
  const currVal_29:any = (_decl0_121.nzAlign === 'bottom');
  currVal_29;
  const currVal_30:any = (_decl0_121.nzJustify === 'start');
  currVal_30;
  const currVal_31:any = (_decl0_121.nzJustify === 'end');
  currVal_31;
  const currVal_32:any = (_decl0_121.nzJustify === 'center');
  currVal_32;
  const currVal_33:any = (_decl0_121.nzJustify === 'space-around');
  currVal_33;
  const currVal_34:any = (_decl0_121.nzJustify === 'space-between');
  currVal_34;
  const currVal_35:any = (_decl0_121.dir === 'rtl');
  currVal_35;
  const currVal_36:any = 6;
  currVal_36;
  const currVal_37:any = _decl0_120.hostFlexStyle;
  currVal_37;
  const currVal_38:any = 'calendar';
  currVal_38;
  const currVal_39:any = true;
  currVal_39;
  const currVal_40:any = 6;
  currVal_40;
  const currVal_41:any = _decl0_120.hostFlexStyle;
  currVal_41;
  const currVal_42:any = 'file';
  currVal_42;
  const currVal_43:any = true;
  currVal_43;
  const currVal_44:any = 6;
  currVal_44;
  const currVal_45:any = _decl0_120.hostFlexStyle;
  currVal_45;
  const currVal_46:any = 'cloud';
  currVal_46;
  const currVal_47:any = true;
  currVal_47;
  const currVal_48:any = 6;
  currVal_48;
  const currVal_49:any = _decl0_120.hostFlexStyle;
  currVal_49;
  const currVal_50:any = 'star';
  currVal_50;
  const currVal_51:any = true;
  currVal_51;
  const currVal_52:any = 6;
  currVal_52;
  const currVal_53:any = _decl0_120.hostFlexStyle;
  currVal_53;
  const currVal_54:any = 'team';
  currVal_54;
  const currVal_55:any = true;
  currVal_55;
  const currVal_56:any = 6;
  currVal_56;
  const currVal_57:any = _decl0_120.hostFlexStyle;
  currVal_57;
  const currVal_58:any = 'scan';
  currVal_58;
  const currVal_59:any = true;
  currVal_59;
  const currVal_60:any = 6;
  currVal_60;
  const currVal_61:any = _decl0_120.hostFlexStyle;
  currVal_61;
  const currVal_62:any = 'pay-circle';
  currVal_62;
  const currVal_63:any = true;
  currVal_63;
  const currVal_64:any = 6;
  currVal_64;
  const currVal_65:any = _decl0_120.hostFlexStyle;
  currVal_65;
  const currVal_66:any = 'printer';
  currVal_66;
  const currVal_67:any = true;
  currVal_67;
  const pd_68:any = ((<any>_decl0_144.change()) !== false);
}
function _View_HeaderFullScreenComponent_Host_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const pd_1:any = ((<any>_decl0_145._resize()) !== false);
  const pd_2:any = ((<any>_decl0_145._click()) !== false);
}
function _View_HeaderFullScreenComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_145.status? 'fullscreen-exit': 'fullscreen');
  currVal_0;
  const currVal_1:any = true;
  currVal_1;
}
function _View_HeaderI18nComponent_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_HeaderI18nComponent_8_1():void {
  if (_decl0_146.showLangText) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_109;
    currVal_0;
    const currVal_1:any = 'bottomRight';
    currVal_1;
    const currVal_2:any = 'global';
    currVal_2;
    const currVal_3:any = true;
    currVal_3;
    const currVal_4:any = _decl0_152.transform(_decl0_146.defaultLanguage$);
    currVal_4;
    const currVal_5:any = 'down';
    currVal_5;
    const currVal_6:any = true;
    currVal_6;
  }
}
function _View_HeaderI18nComponent_8_2():void {
  if (!_decl0_146.showLangText) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_109;
    currVal_0;
    const currVal_1:any = 'bottomRight';
    currVal_1;
    const currVal_2:any = 'global';
    currVal_2;
    const currVal_3:any = true;
    currVal_3;
  }
}
function _View_HeaderI18nComponent_8_3():void {
  var _any:any = (null as any);
  const currVal_0:any = (_any.cultureName === _decl0_146.selectedLangCulture);
  currVal_0;
  const currVal_1:any = _decl0_103.isMenuInsideDropDown;
  currVal_1;
  const currVal_2:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_2;
  const currVal_3:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_3;
  const currVal_4:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_4;
  const currVal_5:any = !_decl0_103.isMenuInsideDropDown;
  currVal_5;
  const currVal_6:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_6;
  const currVal_7:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_7;
  const currVal_8:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_8;
  const currVal_9:any = ((_decl0_103.dir === 'rtl')? null: (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft));
  currVal_9;
  const currVal_10:any = ((_decl0_103.dir === 'rtl')? (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft): null);
  currVal_10;
  const currVal_11:any = ((_any == null)? (null as any): _any.displayName);
  currVal_11;
  const pd_12:any = ((<any>_decl0_103.clickMenuItem(_any)) !== false);
  const pd_13:any = ((<any>_decl0_146.onChangeLang(_any.cultureName)) !== false);
}
function _View_HeaderI18nComponent_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_146.showLangText;
  currVal_0;
  const currVal_1:any = !_decl0_146.showLangText;
  currVal_1;
  const currVal_2:any = _decl0_102.isMenuInsideDropDown;
  currVal_2;
  const currVal_3:any = _decl0_102.isMenuInsideDropDown;
  currVal_3;
  const currVal_4:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_4;
  const currVal_5:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_5;
  const currVal_6:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_6;
  const currVal_7:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_7;
  const currVal_8:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_8;
  const currVal_9:any = (_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_9;
  const currVal_10:any = !_decl0_102.isMenuInsideDropDown;
  currVal_10;
  const currVal_11:any = !_decl0_102.isMenuInsideDropDown;
  currVal_11;
  const currVal_12:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_12;
  const currVal_13:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_13;
  const currVal_14:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_14;
  const currVal_15:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_15;
  const currVal_16:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_16;
  const currVal_17:any = (!_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_17;
  const currVal_18:any = (_decl0_102.dir === 'rtl');
  currVal_18;
  const currVal_19:any = _decl0_152.transform(_decl0_146.dropdownLanguages$);
  currVal_19;
}
function _View_HeaderClearStorageComponent_Host_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
}
function _View_HeaderClearStorageComponent_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'tool';
  currVal_0;
  const currVal_1:any = true;
  currVal_1;
  const currVal_2:any = 'menu.clear.local.storage';
  currVal_2;
}
function _View_HeaderUserComponent_Host_10_0():void {
  var _any:any = (null as any);
}
function _View_HeaderUserComponent_10_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_109;
  currVal_0;
  const currVal_1:any = 'bottomRight';
  currVal_1;
  var tmp_2_0:any = (null as any);
  const currVal_2:any = (((tmp_2_0 = _decl0_152.transform(_decl0_148.currentUser$)) == null)? (null as any): tmp_2_0.userName);
  currVal_2;
}
function _View_HeaderUserComponent_10_2():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bottomRight';
  currVal_0;
  const currVal_1:any = _decl0_165.transform('AbpAccount::Login');
  currVal_1;
  const pd_2:any = ((<any>_decl0_148.navigateToLogin()) !== false);
}
function _View_HeaderUserComponent_10_0():void {
  var _any:any = (null as any);
  var tmp_0_0:any = (null as any);
  const currVal_0:any = (((tmp_0_0 = _decl0_152.transform(_decl0_148.currentUser$)) == null)? (null as any): tmp_0_0.isAuthenticated);
  currVal_0;
  var tmp_1_0:any = (null as any);
  const currVal_1:any = !(((tmp_1_0 = _decl0_152.transform(_decl0_148.currentUser$)) == null)? (null as any): tmp_1_0.isAuthenticated);
  currVal_1;
  const currVal_2:any = _decl0_102.isMenuInsideDropDown;
  currVal_2;
  const currVal_3:any = _decl0_102.isMenuInsideDropDown;
  currVal_3;
  const currVal_4:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_4;
  const currVal_5:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_5;
  const currVal_6:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_6;
  const currVal_7:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_7;
  const currVal_8:any = (_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_8;
  const currVal_9:any = (_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_9;
  const currVal_10:any = !_decl0_102.isMenuInsideDropDown;
  currVal_10;
  const currVal_11:any = !_decl0_102.isMenuInsideDropDown;
  currVal_11;
  const currVal_12:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'light'));
  currVal_12;
  const currVal_13:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.nzTheme === 'dark'));
  currVal_13;
  const currVal_14:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'vertical'));
  currVal_14;
  const currVal_15:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'horizontal'));
  currVal_15;
  const currVal_16:any = (!_decl0_102.isMenuInsideDropDown && (_decl0_102.actualMode === 'inline'));
  currVal_16;
  const currVal_17:any = (!_decl0_102.isMenuInsideDropDown && _decl0_102.nzInlineCollapsed);
  currVal_17;
  const currVal_18:any = (_decl0_102.dir === 'rtl');
  currVal_18;
  const currVal_19:any = _decl0_103.isMenuInsideDropDown;
  currVal_19;
  const currVal_20:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_20;
  const currVal_21:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_21;
  const currVal_22:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_22;
  const currVal_23:any = !_decl0_103.isMenuInsideDropDown;
  currVal_23;
  const currVal_24:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_24;
  const currVal_25:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_25;
  const currVal_26:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_26;
  const currVal_27:any = ((_decl0_103.dir === 'rtl')? null: (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft));
  currVal_27;
  const currVal_28:any = ((_decl0_103.dir === 'rtl')? (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft): null);
  currVal_28;
  const currVal_29:any = 'user';
  currVal_29;
  const currVal_30:any = true;
  currVal_30;
  const currVal_31:any = _decl0_165.transform('AbpAccount::ManageYourProfile');
  currVal_31;
  const currVal_32:any = _decl0_103.isMenuInsideDropDown;
  currVal_32;
  const currVal_33:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_33;
  const currVal_34:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_34;
  const currVal_35:any = (_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_35;
  const currVal_36:any = !_decl0_103.isMenuInsideDropDown;
  currVal_36;
  const currVal_37:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzSelected);
  currVal_37;
  const currVal_38:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDanger);
  currVal_38;
  const currVal_39:any = (!_decl0_103.isMenuInsideDropDown && _decl0_103.nzDisabled);
  currVal_39;
  const currVal_40:any = ((_decl0_103.dir === 'rtl')? null: (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft));
  currVal_40;
  const currVal_41:any = ((_decl0_103.dir === 'rtl')? (_decl0_103.nzPaddingLeft || _decl0_103.inlinePaddingLeft): null);
  currVal_41;
  const currVal_42:any = 'logout';
  currVal_42;
  const currVal_43:any = true;
  currVal_43;
  const currVal_44:any = _decl0_165.transform('AbpUi::Logout');
  currVal_44;
  const pd_45:any = ((<any>_decl0_103.clickMenuItem(_any)) !== false);
  const pd_46:any = ((<any>_decl0_148.navigateToManageProfile()) !== false);
  const pd_47:any = ((<any>_decl0_103.clickMenuItem(_any)) !== false);
  const pd_48:any = ((<any>_decl0_148.logout()) !== false);
}
function _View_HeaderRTLComponent_Host_11_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const pd_1:any = ((<any>_decl0_149.toggleDirection()) !== false);
}
function _View_HeaderRTLComponent_11_0():void {
  var _any:any = (null as any);
  const currVal_0:any = ((_decl0_149.rtl.nextDir === 'rtl')? 'border-left': 'border-right');
  currVal_0;
  const currVal_1:any = true;
  currVal_1;
  const currVal_2:any = _decl0_153.transform(_decl0_149.rtl.nextDir);
  currVal_2;
}
function _View_LayoutPassportComponent_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_LayoutPassportComponent_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'false';
  currVal_0;
  const currVal_1:any = (((_decl0_152.transform(_decl0_150.environmentService.getEnvironment$()).application == null)? (null as any): _decl0_152.transform(_decl0_150.environmentService.getEnvironment$()).application.logoUrl) || './assets/logo-color.svg');
  currVal_1;
  const currVal_2:any = ((_decl0_152.transform(_decl0_150.environmentService.getEnvironment$()).application == null)? (null as any): _decl0_152.transform(_decl0_150.environmentService.getEnvironment$()).application.name);
  currVal_2;
}
function _View_BreadcrumbComponent_Host_13_0():void {
  var _any:any = (null as any);
}
function _View_BreadcrumbComponent_13_3():void {
  if ((_decl0_151.segments.length > 0)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_165.transform(_any.name);
    currVal_0;
  }
}
function _View_BreadcrumbComponent_13_2():void {
  if ((_decl0_151.segments.length > 0)) {
    var _any:any = (null as any);
    const currVal_0:any = '/';
    currVal_0;
    const currVal_1:any = _decl0_39.target;
    currVal_1;
    const currVal_2:any = _decl0_39.href;
    currVal_2;
    const currVal_3:any = _decl0_151.segments;
    currVal_3;
    const pd_4:any = ((<any>_decl0_39.onClick(_any.button,_any.ctrlKey,_any.shiftKey,
        _any.altKey,_any.metaKey)) !== false);
  }
}
function _View_BreadcrumbComponent_13_1():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_151.segments.length > 0);
  currVal_0;
}
function _View_BreadcrumbComponent_13_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_191;
  currVal_1;
}
